import React from "react";
import { Line } from "react-chartjs-2";

const SpecialLineChartForKPI06 = ({ kpi }) => {
  const data = {
    labels: [
      "Avg Target",
      "Avg Actual",
      "Internal Benchmark",
      "External Benchmark",
      "New Target",
    ],
    datasets: [
      {
        label: kpi.kpi_code,
        data: [
          kpi.avg_target_performance,
          kpi.avg_actual_performance,
          kpi.avg_internal_benchmark,
          kpi.avg_external_benchmark,
          kpi.avg_new_target_performance,
        ],
        borderColor: "#363062",
        borderWidth: 2,
        backgroundColor: "rgba(64, 24, 157, 0.2)",
        pointBackgroundColor: "#363062",
        fill: true,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: true,
    },
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            stepSize: 10,
            max: 100,
          },
        },
      ],
      xAxes: [
        {
          ticks: {
            fontFamily: "Cairo",
          },
        },
      ],
    },
  };

  return (
    <div className="card mt-4 p-3" style={{ height: "300px" }}>
      <h5 className="mb-3">{kpi.kpi_code}</h5>
      <Line data={data} options={options} />
    </div>
  );
};

export default SpecialLineChartForKPI06;
